module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medicalNews commonMedical",
    attrs: {
      "data": _vm.detailList
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("基础信息")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("病例名称：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detailList.caseName))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detailList.caseSex))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("年龄：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detailList.caseAge))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("创建时间：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detailList.createDate))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("创建人：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detailList.creatorName))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "dif_col"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content info_length"
  }, [_vm._v(_vm._s(_vm.detailList.remark))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("就诊信息")])]), _vm._v(" "), _c('el-row', {
    staticClass: "dif_col"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("病史：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content info_length info_next"
  }, [_vm._v(_vm._s(_vm.detailList.history))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "dif_col"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("病理结果：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content info_length info_next"
  }, [_vm._v(_vm._s(_vm.detailList.caseResult))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "dif_col"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("影像所见：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content info_length info_next"
  }, [_vm._v(_vm._s(_vm.detailList.evidence))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "dif_col"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("诊断结果：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content info_length info_next"
  }, [_vm._v(_vm._s(_vm.detailList.dianogeResult))])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-48e3c985","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/medicalNews/medicalNewsDetail.vue
// module id = 562
// module chunks = 1 2 3 4 5 6 7 8